const links = () => {
  window.link_clicks = [];

  document.addEventListener('click', (e) => {
    const target = e.target.closest('a, [data-track-link]');
    if (!target) return;

    const href = target.getAttribute('href');

    document.dispatchEvent(new CustomEvent('linkWillNavigate', { detail: window.link_clicks[0] }));
    window.link_clicks.unshift(target);

    // Only track the last 50 link clicks, remove excess for memory/performance reasons (who clicks 50 things???)
    if (window.link_clicks.length > 50) {
      window.link_clicks.pop();
    }

    if (window.theme.external_links_in_new_window && href) {
      let link_domain = href.split('http')[1];

      if (link_domain) {
        const domain = window.location.hostname.replace('www.', '');
        link_domain = link_domain.split('://')[1];

        if (link_domain) {
          link_domain = link_domain.split('/')[0].replace('www.', '');

          if (link_domain !== domain) {
            e.preventDefault();
            window.open(href);
          }
        }
      }
    }

    document.dispatchEvent(new CustomEvent('linkDidNavigate', { detail: window.link_clicks[0] }));
  });
};

export { links };
